import { useQuery } from "react-query";
import { AuthIntegrationApi, AxiosEmployeeAPI } from "../../Api";
import { useSettingValue } from "../../../utils/Hooks";

export const useEmployee = (employeeId) =>
  useQuery(
    ["get_employee", employeeId],
    () =>
      AxiosEmployeeAPI.getById(
        {
          employee_id: employeeId,
          expand: "user",
        },
        {}
      ),
    { refetchOnWindowFocus: false }
  );

export const useEmployeePermissions = (employee) => {
  const isIntegrationAuthEnabled = useSettingValue("INTEGRATION_AUTH_ENABLED");

  return useQuery(
    ["employeePermission", employee?.user?.uuid, isIntegrationAuthEnabled],
    () =>
      isIntegrationAuthEnabled
        ? AuthIntegrationApi.getPermissions(employee?.user?.uuid)
        : [],
    {
      enabled: !!employee?.user?.uuid,
      keepPreviousData: true,
      refetchOnWindowFocus: false,
    }
  );
};
